import { Box, IconButton, Typography } from '@mui/material'
import React from 'react'
import ExpandIcon from '@assets/Settings/Expand.svg'
import { useAppTheme } from '@/theme/ThemeContext'

type SectionHeaderProps = {
  title: string
  icon: string | React.ReactNode
  isOpen?: boolean
  onExpandClick?: () => void
}

const SectionHeader = ({ title, icon, isOpen = false, onExpandClick }: SectionHeaderProps) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  const darkFilter = 'brightness(0) invert(40%) sepia(31%) saturate(5377%) hue-rotate(63deg) brightness(96%) contrast(90%)'

  return (
    <Box
      onClick={onExpandClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        direction: 'rtl',
        cursor: onExpandClick ? 'pointer' : 'default',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {typeof icon === 'string' ? (
          <img src={icon} alt="" style={{ filter: isDarkMode ? darkFilter : 'none' }} />
        ) : (
          <Box sx={{ color: isDarkMode ? '#84C081' : '#84C081', display: 'flex' }}>
            {icon}
          </Box>
        )}
        <Typography
          sx={{
            color: isDarkMode ? '#BBD7FF' : '#003F61',
            fontFamily: 'Rubik, sans-serif',
            fontSize: 'clamp(14px, 1.1vw, 20px)',
            fontWeight: 500,
            lineHeight: '24px',
          }}
        >
          {title}
        </Typography>
      </Box>

      {onExpandClick && (
        <IconButton
          aria-label="expand-section"
          onClick={(event) => {
            event.stopPropagation()
            onExpandClick()
          }}
          sx={{
            width: 'clamp(28px, 2.2vw, 40px)',
            height: 'clamp(28px, 2.2vw, 40px)',
            borderRadius: '10px',
            p: 0.5,
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
          }}
        >
          <img src={ExpandIcon} alt="expand" style={{ width: 20, height: 20, filter: isDarkMode ? darkFilter : 'none' }} />
        </IconButton>
      )}
    </Box>
  )
}

export default SectionHeader
